export enum BaladaAppType {
  OTHERS = 'OTHERS',
  TICKETS = 'TICKETS',
  MEMBERSHIPS = 'MEMBERSHIPS',
}

export type BaladaApp = {
  uuid: string;
  title: string;
  identifier: string;
  type: BaladaAppType;
  image_url: string;
  source_url: string;
  created_at: string;
  updated_at: string;
};

export const translateBaladaAppType = (type: BaladaAppType): string => {
  switch (type) {
    case BaladaAppType.OTHERS:
      return 'Outros';
    case BaladaAppType.TICKETS:
      return 'Ingressos';
    case BaladaAppType.MEMBERSHIPS:
      return 'Sócio-torcedor';
    default:
      return type;
  }
};

export const colorByBaladaAppType = (type: BaladaAppType): string => {
  switch (type) {
    case BaladaAppType.TICKETS:
      return 'brand.500';
    case BaladaAppType.MEMBERSHIPS:
      return 'green.500';
    case BaladaAppType.OTHERS:
      return 'gray.500';
    default:
      return 'gray.500';
  }
};
